import { Component, ViewChild, Injector, Output, EventEmitter, OnInit, ElementRef, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { finalize } from 'rxjs/operators';
import {
    OrderGuideServiceProxy,
    ArticleServiceProxy,
    ArticleDto,
    PagedResultDtoOfArticleDto,
    FieldTypes
} from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';
import moment from 'moment';

import { SearchAndSelectComponent } from
    '@app/shared/common/shop-system/common/search-and-select/search-and-select.component';
import { ColumnDefinition, AxillaPallet, AxillaPalletDimension } from '@app/shared/common/shop-system/models/models';
import { IColumnDefinition } from '@app/shared/common/shop-system/models/models';

@Component({
    selector: 'app-small-pallet',
    templateUrl: './small-pallet-details.component.html',
    styleUrls: ['./small-pallet-details.component.less']
})
export class SmallPalletDetailsComponent extends AppComponentBase implements OnInit {

    @Input() pallet: AxillaPallet;

    get dimension(): AxillaPalletDimension {
        return this.pallet.dimension;
    }

    get isShowDimention(): boolean {
        return this.pallet.showDimension;
    }

    constructor(
        injector: Injector,
        private _orderGuideServiceProxy: OrderGuideServiceProxy,
        private _articleServiceProxy: ArticleServiceProxy,
        private _activatedRoute: ActivatedRoute
    ) {
        super(injector);
    }

    ngOnInit(): void {
    }

    getOverlayHeight(): string {

        if(this.pallet) {
            let height = this.pallet.usedSpace;
            return `used-${Math.round(height / 10) * 10}`;
        }


        return 'used-0';
    } 

}
